import { Svg } from '../../..'

export interface SearchIconProps {
  className: string
}

export const SearchIcon = ({ className }: SearchIconProps) => (
  <Svg className={className} width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M16 14.7692C16 15.4359 15.4359 16 14.7692 16C14.4444 16 14.1368 15.8632 13.8974 15.641L10.5983 12.3419C9.48718 13.1282 8.13675 13.5385 6.76923 13.5385C3.02564 13.5385 0 10.5128 0 6.76923C0 3.02564 3.02564 0 6.76923 0C10.5128 0 13.5385 3.02564 13.5385 6.76923C13.5385 8.13675 13.1282 9.48718 12.3419 10.5983L15.641 13.8974C15.8632 14.1197 16 14.4444 16 14.7692ZM11.0769 6.76923C11.0769 4.39316 9.1453 2.46154 6.76923 2.46154C4.39316 2.46154 2.46154 4.39316 2.46154 6.76923C2.46154 9.1453 4.39316 11.0769 6.76923 11.0769C9.1453 11.0769 11.0769 9.1453 11.0769 6.76923Z'
      fill='white'
    />
  </Svg>
)
